import { styled } from "@mui/system";
import {
  MAX_WIDTH,
  DISPLAY_FLEX,
  FLEX_DIRECTION_COLUMN,
  FLEX_ALIGN_CENTER,
  FLEX_DIRECTION_ROW,
  FLEX_JUSTIFY_END,
  FLEX_JUSTIFY_SPACE_BETWEEN,
  POSITION_RELATIVE,
  TEXT_ALIGN_CENTER,
  BACKGROUND_REPEAT_NO_REPEAT,
  BACKGROUND_SIZE_COVER,
  BACKGROUND_SIZE_CONTAIN,
  OVERFLOW_HIDDEN,
  FONT_WEIGHT_EXTRA_BOLD,
  LINE_HEIGHT_XXL,
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_NORMAL,
  TEXT_ALIGN_LEFT,
  FONT_SIZE_MD,
  TEXT_DECORATION_NONE,
  BORDER_PRIMARY,
  POSITION_ABSOLUTE,
  FLEX_JUSTIFY_CENTER,
} from "../../config/styles";
import { colors } from "../../config/colors";

export const LoginPageStyled = styled("div")(({ theme }) => ({
  display: DISPLAY_FLEX,
  flexDirection: FLEX_DIRECTION_ROW,
  height: "100vh",
  width: "100vw",
  position: POSITION_RELATIVE,
  backgroundColor: theme.palette.background.default,
  justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
  "& .login-body-container": {
    display: DISPLAY_FLEX,
    flex: 2,
    backgroundColor: theme.palette.background.default,
    padding: "2.5rem",
  },
  "& .login-section-container": {
    display: DISPLAY_FLEX,
    flex: 1,
    background: theme.palette.primary.main,
    padding: ".75rem",
    flexDirection: FLEX_DIRECTION_COLUMN,
    justifyContent: FLEX_ALIGN_CENTER,
  },
  "& .login-logo-wrapper": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    alignItems: FLEX_ALIGN_CENTER,
    width: MAX_WIDTH,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
    height: MAX_WIDTH,
  },
  "& .powered-by-rak": {
    position: POSITION_RELATIVE,
    backgroundRepeat: BACKGROUND_REPEAT_NO_REPEAT,
    backgroundSize: BACKGROUND_SIZE_COVER,
    objectFit: BACKGROUND_SIZE_CONTAIN,
    marginBottom: ".5rem",
  },
  "& .carousel-container": {
    display: DISPLAY_FLEX,
    alignItems: FLEX_ALIGN_CENTER,
    justifyContent: FLEX_ALIGN_CENTER,
    overflow: OVERFLOW_HIDDEN,
    height: "100vh",
  },
  "& .carousel-viewport": {
    position: POSITION_RELATIVE,
    height: "1100px",
    overflow: OVERFLOW_HIDDEN,
    width: "300px !important",
  },
  "& .carousel-item": {
    position: POSITION_ABSOLUTE,
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    width: "300px !important",
    height: "220px !important",
    justifyContent: FLEX_ALIGN_CENTER,
    alignItems: FLEX_ALIGN_CENTER,
    borderRadius: "40px",
    borderWidth: "6px",
    borderStyle: "solid",
    gap: "1rem",
    transition: "transform 0.6s ease, opacity 0.6s ease",
    pointerEvents: "none",
    padding: "1rem",
  },
  "& .carosuel-item-active-logo": {
    padding: "0 1.5rem",
    display: DISPLAY_FLEX,
    color: theme.palette.primary.main,
    width: MAX_WIDTH,
    justifyContent: FLEX_JUSTIFY_END,
    marginBottom: "-1.5rem",
  },
  "& .carosuel-item-active-text": {
    color: theme.palette.primary.main,
    textAlign: TEXT_ALIGN_CENTER,
    fontFamily: "DM Sans, sans-serif",
    fontSize: "2rem",
    fontStyle: "normal",
    fontWeight: FONT_WEIGHT_EXTRA_BOLD,
    lineHeight: "2.5rem",
    padding: "0 1.5rem",
  },
  "& .login-container": {
    paddingTop: "6%",
  },
  "& .login-header": {
    color: theme.palette.text.primary,
    textAlign: TEXT_ALIGN_CENTER,
    fontFamily: "Open Sans, sans-serif",
    fontSize: "28px",
    fontWeight: FONT_WEIGHT_BOLD,
    lineHeight: LINE_HEIGHT_XXL,
    letterSpacing: "-0.56px",
  },
  "& .login-subheader": {
    color: theme.palette.text.secondary,
    textAlign: TEXT_ALIGN_CENTER,
    fontFamily: "Open Sans, sans-serif",
    fontSize: "14px",
    fontWeight: FONT_WEIGHT_NORMAL,
    lineHeight: "18px",
    width: "335px",
    margin: "12px auto",
  },
  "& .login-section": {
    width: "400px !important",
    margin: "0 auto",
    padding: "0",
  },

  "& .login-text-field": {
    color: theme.palette.primary.input,
    ...theme.typography.body1,
    height: "60px !important",
    letterSpacing: "0px",
    lineHeight: "1rem",
    border: BORDER_PRIMARY,
    padding: "1rem",
    borderRadius: "12px",
    width: MAX_WIDTH,
    textAlign: TEXT_ALIGN_LEFT,
  },
  "& .text-muted": {
    textAlign: TEXT_ALIGN_LEFT,
  },
  "& .login-failure": {
    marginTop: "22%",
    color: theme.palette.text.danger,
    fontSize: FONT_SIZE_MD,
    fontWeight: FONT_WEIGHT_BOLD,
  },
  "& .forgot-password-container": {
    display: DISPLAY_FLEX,
    justifyContent: FLEX_JUSTIFY_END,
    width: "400px",
    margin: "0 auto",
    background: "transparent",
  },
  "& .forgot-password": {
    color: theme.palette.primary.main,
    fontFamily: "Open Sans, sans-serif",
    fontSize: FONT_SIZE_MD,
    fontWeight: FONT_WEIGHT_NORMAL,
    lineHeight: "18px",
    textDecoration: TEXT_DECORATION_NONE,
    cursor: "pointer",
    border: "none",
    marginBottom: "37px",
    background: "transparent",
  },
  "& .login-button": {
    display: DISPLAY_FLEX,
    width: "400px",
    height: "52px",
    fontFamily: "Open Sans, sans-serif",
    fontSize: FONT_SIZE_MD,
    background: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    padding: "8px 12px",
    justifyContent: FLEX_ALIGN_CENTER,
    alignItems: FLEX_ALIGN_CENTER,
    gap: ".5rem",
    margin: "0 auto",
    fontWeight: FONT_WEIGHT_BOLD,
    borderRadius: ".75rem",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
    "&:disabled": {
      background: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      opacity: 0.5,
      cursor: "not-allowed",
      userSelect: "none",
    },
  },
  "& .back-button": {
    display: DISPLAY_FLEX,
    width: "400px",
    height: "52px",
    fontFamily: "Open Sans, sans-serif",
    fontSize: FONT_SIZE_MD,
    borderColor: theme.palette.primary.main,
    padding: "8px 12px",
    justifyContent: FLEX_ALIGN_CENTER,
    alignItems: FLEX_ALIGN_CENTER,
    gap: ".5rem",
    margin: "0 auto",
    fontWeight: FONT_WEIGHT_BOLD,
    borderRadius: ".75rem",
    background: theme.palette.secondary.contrastText,
    border: BORDER_PRIMARY,
    color: theme.palette.text.primary,
    "&:hover": {
      backgroundColor: colors.grayBackground,
      border: "none",
      color: theme.palette.text.primary,
    },
  },
  "& .login-email-feedback": {
    ...theme.typography.subtitle2,
    display: DISPLAY_FLEX,
    alignItems: FLEX_ALIGN_CENTER,
    width: "400px !important",
    margin: "0.2rem auto",
    gap: "0.1rem",
  },
  "& .step-active": {
    width: "32px",
    height: "32px",
    display: DISPLAY_FLEX,
    justifyContent: FLEX_JUSTIFY_CENTER,
    alignItems: FLEX_ALIGN_CENTER,
    color: theme.palette.secondary.contrastText,
    backgroundColor: colors.primary,
    padding: "8px",
    borderRadius: "50%",
  },
  "& .step-inactive": {
    width: "32px",
    height: "32px",
    display: DISPLAY_FLEX,
    justifyContent: FLEX_JUSTIFY_CENTER,
    alignItems: FLEX_ALIGN_CENTER,
    color: colors.grayLight,
    backgroundColor: colors.storkeLight,
    padding: "8px",
    borderRadius: "50%",
  },
  "& .divider-active": {
    height: "5px",
    backgroundColor: colors.primary,
    width: "128px",
    borderRadius: "20px",
  },
  "& .divider-inactive": {
    height: "5px",
    backgroundColor: colors.storkeLight,
    width: "128px",
    borderRadius: "20px",
  },
  "& .divider-progress": {
    backgroundColor: colors.primary,
    width: "32px",
    height: "5px",
  },
  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
    "-webkit-appearance": "none",
    margin: 0,
  },
  '& input[type="number"]': {
    "-moz-appearance": "textfield",
  },
  "& .password-list-group": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    width: "400px",
    flexWrap: "wrap",
  },
  "& .password-list-item": {
    flex: "50%",
    ...theme.typography.h4,
    color: colors.uiGrey,
  },
}));
